import React from 'react';
import { AddToBasketProfile } from '../../ui';

export const JoinNetwork = props => {
    const { networkTitle, openModal } = props;
    return (
        <div>
            <AddToBasketProfile { ...props } />
            <div className="row">
                <div className="col-xs-8 col-md-9">
                    <p className="p-tag">Your profile <b>is not published</b> on { networkTitle }, which means no one but you can see it. <b>To publish your profile, you need to be a member of { networkTitle }</b>.</p>
                </div>
                <div className="col-xs-4 col-md-3">
                    <ul className="buttons-right">
                        <li>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={ () => openModal() } >
                                <span className="label">Join now</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/JoinNetwork.js